export enum ViewLayoutPlacement {
  VIEW_LAYOUT_PLACEMENT_UNKNOWN = 'VIEW_LAYOUT_PLACEMENT_UNKNOWN',
  /**
   * Used when CategoryPageLayoutRequest only intend to fetch the top section of the SDUI category page
   */
  TOP = 'TOP',
  /**
   * Used when CategoryPageLayoutRequest only intend to fetch the filterable paginated section of the SDUI category page
   */
  FPS = 'FPS',
  /**
   * Used when CategoryPageLayoutRequest fetches the all sections of the SDUI category page
   */
  ALL_PLACEMENTS = 'ALL_PLACEMENTS',
}
